// src/Views/HomePage.js
import React from 'react';
import './HomePage.css';
import TopFold from './TopFold.js';

const HomePage = () => {
    return (
        <div className="expert-homepage">
            <TopFold />
        </div>
    );
};

export default HomePage;

